import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNotify } from '../../../../../hooks';
import { useExecutiveSummaryData } from '../Context';
import { messages } from '../messages';
import {
  AgentInput,
  useExecutiveSummaryGeneration,
} from '../useExecutiveSummaryGeneration';

export const useRequestExecutiveSummary = ({
  patientId,
}: {
  patientId: string;
}) => {
  const { formatMessage } = useIntl();
  const [notify] = useNotify();
  const { executiveSummary } = useExecutiveSummaryData();
  const { isGenerating, generateExecutiveSummary } =
    useExecutiveSummaryGeneration({
      patientId,
    });

  const requestExecutiveSummary = useCallback(
    async (agentInput: AgentInput, context: { isRegenerate: boolean }) => {
      if (isGenerating) {
        return;
      }
      try {
        await generateExecutiveSummary(agentInput, {
          isRegenerate: context.isRegenerate,
          surface: 'annual_report',
          hasImpressions: (executiveSummary?.impressions.length ?? 0) > 0,
        });
      } catch (err) {
        console.error(err);
        notify(formatMessage(messages.generateFailure), 'error');
      }
    },
    [
      generateExecutiveSummary,
      isGenerating,
      formatMessage,
      notify,
      executiveSummary?.impressions.length,
    ],
  );

  return { requestExecutiveSummary };
};
